import type { OrderSettingsDropdown } from '@/api/models/OrderSettings';
import { useId } from 'react';
import Checkbox from '@/common/Checkbox';
import styles from './EmailNotifications.module.scss';

interface EmailNotificationsProps {
  options: OrderSettingsDropdown[];
  selectedIds: number[];
  // eslint-disable-next-line no-unused-vars
  onChange: (selectedIds: number[]) => void;
  disabled?: boolean;
}

export function EmailNotifications({ options, selectedIds, onChange, disabled = false }: EmailNotificationsProps) {
  const titleId = useId();
  const changeSelection = (id: number, checked: boolean) => {
    if (disabled) return;
    const nextIds = selectedIds.filter((selectedId) => selectedId !== id);
    if (checked) nextIds.push(id);
    onChange(nextIds);
  };

  return (
    <section className={styles.notifications}>
      <h2 id={titleId} className={styles.title}>
        Email Notifications
      </h2>
      <fieldset disabled={disabled} aria-labelledby={titleId} className={styles.options}>
        {options.map((option) => (
          <Checkbox key={option.id} className={styles.option} label={option.name} checked={selectedIds.includes(option.id)} onClick={(checked) => changeSelection(option.id, checked)} />
        ))}
      </fieldset>
    </section>
  );
}
